/* import __COLOCATED_TEMPLATE__ from './workflow.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
interface Signature {
  Args: {
    onNext?: () => void;
  };
}

export default class WorkflowComponent extends Component<Signature> {
  @service declare finStandaloneService: FinStandaloneService;

  get salesforceConfig() {
    return this.finStandaloneService.salesforcePlatform.salesforceConfig!;
  }

  get isComplete() {
    return this.salesforceConfig.isEnabled || this.salesforceConfig.isWorkflowValid;
  }

  get isLoading() {
    return (
      this.finStandaloneService.salesforcePlatform.salesforceDataLoader.isLoadingSalesforceConfig ||
      this.finStandaloneService.salesforcePlatform.salesforceDataLoader.isLoadingSalesforceSetupData
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Cases::Workflow': typeof WorkflowComponent;
  }
}
